
import React from 'react'
import { useSelector } from 'react-redux';

const H4 = ({ whiteThemeColor, darkThemeColor, children }) => {

    const fontSizeMultiplier = useSelector((state) => state.fontSizeMultiplier.fontSize);
    const darkWhiteThemeToggle = useSelector((state) => state.darkWhiteThemeToggle.theme);

    return (
        <h4 style={{ fontSize: `${15 * fontSizeMultiplier / 100}px`, color: `${darkWhiteThemeToggle === "WHITE" ? whiteThemeColor = "#5F5553" : darkThemeColor = "#fff"}` }}>{children}</h4>
    )
}

export default H4